export const GET_CAREGIVER_PROFILE = 'get_caregiver_profile';
export const RESET_CAREGIVER_PROFILE = 'reset_caregiver_profile';
